'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = themeit;

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _addJsCss = require('./functions/addJsCss');

var _addJsCss2 = _interopRequireDefault(_addJsCss);

var _parseThemes = require('./functions/parseThemes');

var _parseThemes2 = _interopRequireDefault(_parseThemes);

var _mergeStyles = require('./functions/mergeStyles');

var _mergeStyles2 = _interopRequireDefault(_mergeStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * themeit makes it dead simple to make a component themable.
 *
 * Usage:
 *
 * themeit({
 *  default: 'blue',
 *  base: cb => require(['path/to/base.less'], cb),
 *  mergeContext: false,
 *  themes: {
 *    blue: cb => require(['path/to/themes/blue.less'], cb)
 *    italic: {
 *      myLabel: {
 *        fontStyle: 'italic'
 *      }
 *    }
 *  }
 * })(MyComponent)
 */
function themeit(opts) {
  var options = (0, _extends3.default)({
    mergeContext: false,
    themes: {}
  }, opts);

  var themeCount = (0, _keys2.default)(options.themes).length;

  return function (TargetComponent) {
    var ThemeIt = function (_Component) {
      (0, _inherits3.default)(ThemeIt, _Component);

      function ThemeIt(props, context) {
        (0, _classCallCheck3.default)(this, ThemeIt);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ThemeIt.__proto__ || (0, _getPrototypeOf2.default)(ThemeIt)).call(this, props, context));

        _initialiseProps.call(_this);

        _this.prevContext = context;

        _this._isMounted = false;

        _this.state = {
          styles: {},
          loadedTheme: false
        };
        return _this;
      }

      (0, _createClass3.default)(ThemeIt, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this._isMounted = true;

          this.loadTheme(this.props);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (prevProps.theme !== this.props.theme || (options.mergeContext || this.props.mergeContext) && (0, _stringify2.default)(this.prevContext.styles) !== (0, _stringify2.default)(this.context.styles)) {
            this.loadTheme(this.props);
          }
          this.prevContext = this.context;
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          this._isMounted = false;
        }

        /**
         * Allows you to access the wrapped component
         * @return {ReactElement}
         */

      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          var _state = this.state,
              loadedTheme = _state.loadedTheme,
              styles = _state.styles;


          if (loadedTheme || themeCount <= 0) {
            return (0, _react.createElement)(TargetComponent, (0, _extends3.default)({}, this.props, {
              styles: styles,
              themeit: this.getthemeitProps(),
              ref: function ref(targetComponent) {
                _this2.targetComponent = targetComponent;
              }
            }));
          }

          return null;
        }
      }]);
      return ThemeIt;
    }(_react.Component);

    ThemeIt.displayName = 'ThemeIt(' + TargetComponent.displayName + ')';
    ThemeIt.themeitOptions = options;
    ThemeIt.propTypes = (0, _extends3.default)({
      // name of the theme to use
      theme: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
      // optional jscss styles to be added
      // (will be appended to head with aphrodite)
      styles: _propTypes2.default.object, // eslint-disable-line
      // optional css imports to be added
      // (must be a function which calls cb(classMap1, classMap2))
      addStyleFiles: _propTypes2.default.func, // eslint-disable-line
      // should context be merged?
      mergeContext: _propTypes2.default.bool
    }, TargetComponent.propTypes || {});
    ThemeIt.defaultProps = (0, _extends3.default)({
      theme: options.default || false,
      mergeContext: false
    }, TargetComponent.defaultProps || {});
    ThemeIt.contextTypes = {
      styles: _propTypes2.default.object
    };
    ThemeIt.childContextTypes = {
      styles: _propTypes2.default.object
    };

    var _initialiseProps = function _initialiseProps() {
      var _this3 = this;

      this.getChildContext = function () {
        return {
          styles: _this3.state.styles
        };
      };

      this.setStyles = function () {
        var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        if (_this3._isMounted) {
          var mergeContext = options.mergeContext || _this3.props.mergeContext;

          // if mergeContext is true, and we have styles in context, add them to our styles array
          if (mergeContext && _this3.context.styles) {
            classes.unshift(_this3.context.styles);
          }

          _this3.setState({ styles: _mergeStyles2.default.apply(undefined, (0, _toConsumableArray3.default)(classes)), loadedTheme: true });
        }
      };

      this.getthemeitProps = function () {
        return (0, _extends3.default)({
          setTheme: function setTheme(theme) {
            return _this3.loadTheme((0, _extends3.default)({}, _this3.props, { theme: theme }));
          }
        }, options);
      };

      this.getComponent = function () {
        return _this3.targetComponent;
      };

      this.loadTheme = function (props) {
        var base = options.base,
            themes = options.themes;
        var theme = props.theme;

        var styles = [];

        // if base styles are defined, push them to our array
        if (base) styles.push(base);

        // add styles from defined themes to our styles array
        styles = [].concat((0, _toConsumableArray3.default)(styles), (0, _toConsumableArray3.default)((0, _parseThemes2.default)(theme, themes)));

        // if addStyleFiles is defined, push the addStyleFiles function to the styles array
        if (props.addStyleFiles) {
          styles.push(props.addStyleFiles);
        }

        // if addStyleFiles is defined, push the addStyleFiles function to the styles array
        if (props.addFiles) {
          // eslint-disable-next-line
          console.warn("(react-themeit) 'addFiles' is deprecated and will be removed " + "in the next major version. Use 'addStyleFiles' instead.");
          styles.push(props.addFiles);
        }

        // if a styles object is defined in props, add it also to our styles array
        if (props.styles) styles.push(props.styles);

        var stylesToLoad = styles.length;

        if (stylesToLoad <= 0) {
          _this3.setStyles();
        } else {
          var loadedStyles = [];

          var styleLoaded = function styleLoaded(index) {
            for (var _len = arguments.length, addedStyles = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
              addedStyles[_key - 1] = arguments[_key];
            }

            var stylesCache = { index: index, styles: [] };
            var len = addedStyles.length;
            var hasHot = len > 0 && typeof addedStyles[len - 1] === 'boolean';

            if (hasHot && addedStyles[len - 1]) {
              _this3.loadTheme(_this3.props);
              return;
            }

            addedStyles.forEach(function (s, i) {
              if (i < len - (hasHot ? 2 : 0)) {
                stylesCache.styles.push(s);
              }
            });

            loadedStyles.push(stylesCache);

            if (loadedStyles.length >= stylesToLoad) {
              loadedStyles.sort(function (a, b) {
                return b.index < a.index;
              });

              var normalizedStyles = loadedStyles.reduce(function (acc, cache) {
                acc = acc.concat(cache.styles);
                return acc;
              }, []);

              _this3.setStyles(normalizedStyles);
            }
          };

          styles.forEach(function (style, index) {
            if (typeof style === 'undefined' || style === '' || style === false) {
              console.warn(TargetComponent.displayName + ' has no theme "' + theme + '"!');
            }

            switch (typeof style === 'undefined' ? 'undefined' : (0, _typeof3.default)(style)) {
              case 'function':
                style(styleLoaded.bind(_this3, index));
                break;
              case 'object':
                styleLoaded(index, (0, _addJsCss2.default)(style));
                break;
              default:
                break;
            }
          });
        }
      };
    };

    if (TargetComponent.propTypes) {
      ThemeIt.propTypes = (0, _extends3.default)({}, TargetComponent.propTypes);
    }
    return ThemeIt;
  };
}